import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove external badges/watermarks
const removeExternalBadges = () => {
  const selectors = [
    'a[href*="emergent"]',
    'div[class*="emergent"]',
    'iframe[src*="emergent"]',
    '[data-emergent]',
  ];
  
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.style.display = 'none';
      el.remove();
    });
  });

  // Remove any fixed positioned elements in bottom-right that aren't ours
  document.querySelectorAll('body > *').forEach(el => {
    if (el.id !== 'root') {
      const style = window.getComputedStyle(el);
      if (style.position === 'fixed' && 
          (style.bottom === '0px' || parseInt(style.bottom) < 50) &&
          (style.right === '0px' || parseInt(style.right) < 50)) {
        if (!el.querySelector('[href*="telcavoip"]')) {
          el.style.display = 'none';
          el.remove();
        }
      }
    }
  });
};

// Run on load and periodically
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    removeExternalBadges();
    setTimeout(removeExternalBadges, 1000);
    setTimeout(removeExternalBadges, 3000);
    setTimeout(removeExternalBadges, 5000);
  });
  
  // Also run immediately and with MutationObserver
  setTimeout(removeExternalBadges, 100);
  
  const observer = new MutationObserver(() => {
    removeExternalBadges();
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
